import { AppThunkAction } from "..";
import { KnownAction, RECEIVE_ASSESSMENT_DATA, REQUEST_ASSESSMENT_DATA } from "./types";
import * as services from "../service";

export const actionCreators = {
    submitAssessmentAnswers:
        (answer: []): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            services
                .submitAssessmentAnswers(answer)
                .then((data) => {
                    dispatch({ type: RECEIVE_ASSESSMENT_DATA, assessmentData: data });
                })
                .catch(function (error) {
                    dispatch({ type: RECEIVE_ASSESSMENT_DATA, assessmentData: [] as any });
                });
            dispatch({ type: REQUEST_ASSESSMENT_DATA });
        },

    requestAssesmentSummary:
        (forceFullyRefresh: boolean): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const appState = getState();

            if (
                appState != null &&
                appState.cyberRiskAssessmentState != null &&
                ((appState.cyberRiskAssessmentState.assessmentData == null && appState.cyberRiskAssessmentState.isLoading === false) || forceFullyRefresh === true)
            ) {
                services
                    .getWhiteHawkAssessmentSummary()
                    .then((data) => {
                        dispatch({ type: RECEIVE_ASSESSMENT_DATA, assessmentData: data });
                    })
                    .catch(function (error) {
                        dispatch({ type: RECEIVE_ASSESSMENT_DATA, assessmentData: [] as any });
                    });
                dispatch({ type: REQUEST_ASSESSMENT_DATA });
            }
        },
};
